import { createContext } from 'react'
import { IContext } from '../../types/icontext'

export const createDataContext = <T>() =>
  createContext<IContext<T>>({
    contextItems: undefined as T | undefined,
    setContextItems: (contextItems: T) => {},
  })
